module.exports = __webpack_public_path__ + "static/media/close.b195082a.svg";